import React, { useState } from 'react';
import { FaSearch, FaPlus, FaEllipsisV, FaCloudDownloadAlt, FaShareAlt, FaTrashAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './DataSets.css';

function DataSets() {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Fixed to 10 items per page
  
  // Sample data for the table
  const dataSets = [
    {
      id: 1,
      name: 'NYC Traffic Data',
      source: 'NYCDOT',
      type: 'Traffic',
      records: '1.2M',
      lastUpdated: '2023-05-15',
      status: 'Active'
    },
    {
      id: 2,
      name: 'Chicago Transit Feeds',
      source: 'CTA',
      type: 'Public Transit',
      records: '890K',
      lastUpdated: '2023-04-30',
      status: 'Active'
    },
    {
      id: 3,
      name: 'SF Bay Area Accidents',
      source: 'SFMTA',
      type: 'Accidents',
      records: '450K',
      lastUpdated: '2023-06-02',
      status: 'Processing'
    },
    {
      id: 4,
      name: 'LA Metro Ridership',
      source: 'LA Metro',
      type: 'Public Transit',
      records: '2.4M',
      lastUpdated: '2023-05-28',
      status: 'Active'
    },
    {
      id: 5,
      name: 'Boston Traffic Patterns',
      source: 'MassDOT',
      type: 'Traffic',
      records: '780K',
      lastUpdated: '2023-04-15',
      status: 'Archived'
    },
    {
      id: 6,
      name: 'Seattle Transit Data',
      source: 'King County Metro',
      type: 'Public Transit',
      records: '920K',
      lastUpdated: '2023-06-10',
      status: 'Active'
    },
    {
      id: 7,
      name: 'Miami Traffic Analysis',
      source: 'FDOT',
      type: 'Traffic',
      records: '680K',
      lastUpdated: '2023-05-22',
      status: 'Active'
    },
    {
      id: 8,
      name: 'Denver Public Transport',
      source: 'RTD',
      type: 'Public Transit',
      records: '550K',
      lastUpdated: '2023-06-05',
      status: 'Processing'
    },
    {
      id: 9,
      name: 'Portland Bike Sharing',
      source: 'PBOT',
      type: 'Micromobility',
      records: '320K',
      lastUpdated: '2023-05-18',
      status: 'Active'
    },
    {
      id: 10,
      name: 'Dallas Highway Flows',
      source: 'TxDOT',
      type: 'Traffic',
      records: '1.4M',
      lastUpdated: '2023-06-08',
      status: 'Active'
    },
    {
      id: 11,
      name: 'Atlanta Public Transit',
      source: 'MARTA',
      type: 'Public Transit',
      records: '1.1M',
      lastUpdated: '2023-05-30',
      status: 'Active'
    },
    {
      id: 12,
      name: 'San Diego Road Incidents',
      source: 'SDPD',
      type: 'Accidents',
      records: '280K',
      lastUpdated: '2023-06-01',
      status: 'Processing'
    },
    {
      id: 13,
      name: 'Phoenix Traffic Sensors',
      source: 'ADOT',
      type: 'Traffic',
      records: '950K',
      lastUpdated: '2023-05-20',
      status: 'Active'
    },
    {
      id: 14,
      name: 'Washington DC Metro',
      source: 'WMATA',
      type: 'Public Transit',
      records: '1.8M',
      lastUpdated: '2023-06-12',
      status: 'Active'
    },
    {
      id: 15,
      name: 'Philadelphia Bike Lanes',
      source: 'PCPC',
      type: 'Micromobility',
      records: '210K',
      lastUpdated: '2023-04-25',
      status: 'Archived'
    },
    {
      id: 16,
      name: 'Minneapolis Snow Routes',
      source: 'Minneapolis PW',
      type: 'Weather',
      records: '150K',
      lastUpdated: '2023-03-10',
      status: 'Archived'
    },
    {
      id: 17,
      name: 'Houston Traffic Cameras',
      source: 'TXDOT',
      type: 'Traffic',
      records: '760K',
      lastUpdated: '2023-06-07',
      status: 'Active'
    },
    {
      id: 18,
      name: 'Detroit Public Transport',
      source: 'DDOT',
      type: 'Public Transit',
      records: '520K',
      lastUpdated: '2023-05-12',
      status: 'Active'
    },
    {
      id: 19,
      name: 'Austin Scooter Usage',
      source: 'ATD',
      type: 'Micromobility',
      records: '430K',
      lastUpdated: '2023-06-04',
      status: 'Processing'
    },
    {
      id: 20,
      name: 'Nashville Traffic Patterns',
      source: 'TDOT',
      type: 'Traffic',
      records: '390K',
      lastUpdated: '2023-05-25',
      status: 'Active'
    },
    {
      id: 21,
      name: 'Baltimore Harbor Crossing',
      source: 'MDTA',
      type: 'Traffic',
      records: '620K',
      lastUpdated: '2023-05-16',
      status: 'Active'
    },
    {
      id: 22,
      name: 'St. Louis Bus Routes',
      source: 'Metro Transit',
      type: 'Public Transit',
      records: '340K',
      lastUpdated: '2023-06-03',
      status: 'Active'
    },
    {
      id: 23,
      name: 'Pittsburgh Bridge Sensors',
      source: 'PennDOT',
      type: 'Infrastructure',
      records: '180K',
      lastUpdated: '2023-04-20',
      status: 'Archived'
    },
    {
      id: 24,
      name: 'New Orleans Flood Routes',
      source: 'NOLA Ready',
      type: 'Weather',
      records: '110K',
      lastUpdated: '2023-05-08',
      status: 'Active'
    },
    {
      id: 25,
      name: 'Cincinnati Traffic Counts',
      source: 'ODOT',
      type: 'Traffic',
      records: '270K',
      lastUpdated: '2023-06-09',
      status: 'Active'
    }
  ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  // Filter datasets based on search query
  const filteredDataSets = dataSets.filter(dataSet => 
    dataSet.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    dataSet.source.toLowerCase().includes(searchQuery.toLowerCase()) ||
    dataSet.type.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Calculate pagination
  const totalPages = Math.ceil(filteredDataSets.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDataSets.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="data-sets-container">
      <div className="data-sets-header">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search data sets by name, source, or type"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <button className="new-dataset-btn">
          <FaPlus />
          <span>New Data Set</span>
        </button>
      </div>

      <div className="data-sets-table-container">
        <table className="data-sets-table">
          <thead>
            <tr>
              <th>Data Set Name</th>
              <th>Source</th>
              <th>Type</th>
              <th>Size</th>
              <th>Last Updated</th>
              <th>Status</th>
              <th className="actions-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map(dataSet => (
                <tr key={dataSet.id}>
                  <td className="dataset-name">{dataSet.name}</td>
                  <td>{dataSet.source}</td>
                  <td>
                    <span className={`dataset-type ${dataSet.type.toLowerCase().replace(' ', '-')}`}>
                      {dataSet.type}
                    </span>
                  </td>
                  <td>{dataSet.records}</td>
                  <td>{dataSet.lastUpdated}</td>
                  <td>
                    <span className={`status-badge ${dataSet.status.toLowerCase()}`}>
                      {dataSet.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button data-tooltip="Download"><FaCloudDownloadAlt /></button>
                      <button data-tooltip="Share"><FaShareAlt /></button>
                      <button data-tooltip="Delete"><FaTrashAlt /></button>
                      <button data-tooltip="More options"><FaEllipsisV /></button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-results">
                  No data sets found matching your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container">
          <div className="pagination">
            <button 
              className="pagination-button" 
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FaChevronLeft />
            </button>
            <div className="page-info">
              Page {currentPage} of {totalPages}
            </div>
            <button 
              className="pagination-button" 
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DataSets; 